import React, { useContext, useMemo } from 'react';
import { CustomersContext, ICustomersContext } from '../../../customersState/customersContext';
import { clientTypes } from 'appConstants';
import { useTranslation } from 'react-i18next';
import breadcrumbs from 'images/breadcrumbs.svg';
import OutsideFormSelect from 'components/Select/OutsideFormSelect';
import style from './ClientTypeSelect.module.scss';

export const ClientTypeSelect: React.FC = () => {
	const { setClientType, selectedClientType } = useContext<ICustomersContext>(CustomersContext);
	const { t } = useTranslation('listing');

	const options = useMemo(
		() => [
			{
				id: null,
				name: t('clientTypeAll'),
				icon: (
					<svg className={style.icon}>
						<use xlinkHref={`${breadcrumbs}#clientTypeAll`} />
					</svg>
				),
			},
			...clientTypes.map((clientType) => ({
				id: clientType.clientTypeID,
				name: t(clientType.clientTypeName),
				icon: (
					<svg className={style.icon}>
						<use xlinkHref={`${breadcrumbs}#${clientType.clientTypeName}`} />
					</svg>
				),
			})),
		],
		[t],
	);

	return (
		<OutsideFormSelect
			containerClassName={style.container}
			testId="ClientTypeSelect"
			name="ClientTypeSelect"
			label="clientTypeLabel"
			onChange={setClientType}
			value={selectedClientType}
			options={options}
			listItemHeight={options.length}
			withSearch={false}
			allowClear={false}
			withValidation={false}
			withEmptyOption={false}
		/>
	);
};
